<template> 
    <main class="mt-5">
      <div class="card mt-3">
        <div class="card-header border-0 not-in-print">
          <h5 class="card-title font-bold">پرینت حواله بین انبار</h5>
        </div>
  
        <div class="card-body" id="print">
          <div
            v-for="(page, pageIndex) in pagedItems"
            :key="pageIndex"
            class="print-page"
          >
   
            <div class="row d-flex justify-content-center mb-3">
              <h4>شناسه حواله: {{ havale.id }}</h4>
              <div class="col-12">
                <div class="d-flex justify-content-between align-items-center">
                  <h4>
                    حواله بین انبار از  
                    <span class="font-bold">{{ havale.from_store.label }}</span> به 
                    <span class="font-bold">{{ havale.to_store.label }}</span>
                  </h4>
                  <h4>
                    تاریخ: <span>{{ havale.created_at | persianDate }}</span>
                  </h4>
                </div>
              </div>
            </div>
  
            
            <table class="styled-table">
              <thead>
                <tr>
                  <th>ردیف</th>
                  <th>محصول</th>
                  <th>SKU</th>
                  <th>قیمت</th>
                  <th>مقدار انتقال</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in page" :key="index">
                  <td>{{ pageIndex * 25 + index + 1 }}</td>
                  <td>{{ item.variety_title }}</td>
                  <td>{{ item.product_sku }}</td>
                  <td>{{ item.variety_price | price }}</td>
                  <td>{{ item.quantity || 0 }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
  
        <div class="card-footer not-in-print" v-if="items.length > 0">
          <div class="d-flex justify-content-center align-items-center">
            <button class="btn btn-purple" onclick="window.print()">چاپ</button>
          </div>
        </div>
      </div>
    </main>
  </template>
  <script>
  export default {
    data() {
      return {
        items: [],
        havale: [],
      };
    },
    mounted() {
      this.loadData(this.$route.query.id);
    },
    computed: {
      pagedItems() {
        const perPage = 25;
        const pages = [];
        for (let i = 0; i < this.items.length; i += perPage) {
          pages.push(this.items.slice(i, i + perPage));
        }
        return pages;
      },
    },
    methods: {
      async loadData(id) {
        try {
          const response = await this.$axios.get("admin/store_transfers/" + id);
          this.havale = response.data.data.transfer;
          this.items = response.data.data.items;
        } catch (e) {
          this.$root.notify(e);
        }
      },
    },
  };
  </script>
  <style scoped>
  .styled-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 10px;
  font-family: Tahoma, Geneva, Verdana, sans-serif;
}
.styled-table,
  .styled-table th,
  .styled-table td {
    
  }
.styled-table td, 
.styled-table th {
  font-size: 16px;       /* فونت بزرگ‌تر */
  height: 45px;          /* ارتفاع سلول ثابت */
  vertical-align: middle; /* وسط چین عمودی */
  border: 2px solid #333; 
  text-align: center;
  
}

.styled-table thead {
  background-color: #4CAF50;
  color: white;
}

.table-responsive-sm {
  height: auto;
}

/* ========== پرینت ========== */
@media print {
  .print-page {
    page-break-after: always;
    break-after: page;
    margin-bottom: 40px;
  }

  .print-page:last-child {
    page-break-after: auto;
    break-after: auto;
  }

  thead {
    display: table-header-group;
  }

  body * {
    visibility: hidden;
  }

  #print,
  #print * {
    visibility: visible;
  }

  .not-in-print {
    display: none !important;
  }

  .app-content .side-app {
    padding: 0 !important;
  }

  #print {
    padding: 0;
    width: 100%;
  }

  .styled-table th,
  .styled-table td {
    font-size: 18px !important;
    
    height: 45px !important;
    vertical-align: middle !important;
  }

  h4 {
    font-size: 14px;
    margin: 0 0 10px;
  }

  .print-page {
    page-break-inside: avoid;
  }
}
  </style>
